<!-- @format -->

<div
  [id]="isMobile() ? 'filter-mobile-' + filterOption().value : 'filter-' + filterOption().value"
  class="single-filter hmf-body-m hmf-align-items-center hmf-mb-xxs">
    @if (!isCategoryFilter()) {
        <hmf-checkbox
            class="filter-name hmf-mr-0 hmf-mb-0"
            [id]="`${isMobile() ? 'mobile-' : ''}${attributeIdentifier()}-${filterOption().value}`"
            [disabled]="disabled()"
            [checked]="checked()"
            [ariaLabel]="ariaLabel()"
            (eventChange)="handleClick()">
        </hmf-checkbox>
    }
    <div
        class="filter-value-count-container hmf-display-flex hmf-justify-content-between hmf-align-items-center"
        [class.hmf-ml-xxxs]="isCategoryFilter()"
        [class.hmf-mt-xxxs]="isFirst() && isCategoryFilter()"
        [attr.role]="isCategoryFilter() ? 'link' : null"
        [attr.tabindex]="isCategoryFilter() ? 0 : null"
        [attr.aria-label]="isCategoryFilter() ? ariaLabel() : null"
        (keydown.space)="handleSpace($event)"
        (click)="handleClick()">
        @if (attributeName() === 'Color') {
        <div class="hmf-display-flex hmf-align-items-center">
            <homefield-color-swatch
                radius="50%"
                class="hmf-ml-xxxs hmf-display-flex"
                height="16px"
                width="16px"
                [tabIndex]="-1"
                [color]="filterOption().value"
                [filterColorSwatchHoverDimension]="true"
                [colorSwatchHoverDimension]="true"
                [imageSrc]="filterOption().value === 'Multi' ? MULTICOLOR_IMAGE : undefined"
                [selected]="selectedOptions().includes(filterOption().value)">
            </homefield-color-swatch>
            {{ filterOption().value }}
        </div>
        } @else {
            <div>{{ displayValue() }}</div>
        }
        @if (!(attributeName() === GTGT_FILTER_NAME && filterOption().value === 'N')) {
            <div [attr.id]="`${isMobile() ? 'mobile-count-' : 'count-'}${attributeIdentifier()}-${filterOption().value}`">
                ({{ filterOption().count }})
            </div>
        }
    </div>
</div>
